module.exports = "<p>\n  usc-campaign works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-campaign/usc-campaign.component.html
// module id = ../../../../../src/app/components/usc-campaign/usc-campaign.component.html
// module chunks = main